import { render, staticRenderFns } from "./mis_edu.vue?vue&type=template&id=40ff64d6&scoped=true"
import script from "./mis_edu.vue?vue&type=script&lang=js"
export * from "./mis_edu.vue?vue&type=script&lang=js"
import style0 from "./mis_edu.vue?vue&type=style&index=0&id=40ff64d6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff64d6",
  null
  
)

export default component.exports